export { uuid, firstLetterUppercase, isEmpty, isNumber, link, toMap, nameToInitials } from "./commonUtility";